import { startCase, toLower } from 'lodash-es'
import { useMemo, Fragment } from 'react'
import { NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL } from '#/consts/neighborhood_level'
import { getNeighborhood } from '#/utils/properties'
// import { getInsight, getInsightDescription } from '#/utils/property'
import InsightCard from '../InsightCard'

type InsightsProps = {
  children?: React.ReactNode
  description: string[][][]
  insightsData: TopHap.PropertyState['insightsData']
  metrics: TopHap.InsightMetric[]
  otherLabel: string[]
  property: TopHap.Property
  tolerance?: number
}
// export const determineInsights = (
//   metrics: TopHap.InsightMetric[],
//   insightsData: TopHap.PropertyState['insightsData']
// ) => {
//   if (!insightsData) { return [] }
//   return (metrics
//     .map(e =>
//       (insightsData[e] && getInsight(
//         insightsData[e],
//         insightsData[e].min,
//         insightsData[e].max,
//         e,
//         getInsightDescription(e)?.tolerance
//       )))
//     .map((e, metricIndex) => (e ? { ...e, metricIndex } : undefined))
//     .filter(e => !!e) as (ReturnType<typeof getInsight> & {
//     metricIndex: number,
//     metric: TopHap.InsightMetric })[])
// }

const Insights: React.FC<InsightsProps> = ({
  children, description, insightsData, metrics,
  otherLabel,
  property
}) => {
  // const insights = useMemo(
  //   () => determineInsights(
  //     metrics,
  //     insightsData
  //   ),
  //   [insightsData]
  // )
  const insights: any[] = useMemo(
    () => [],
    [insightsData]
  )
  const neighborhoodName = useMemo(() => {
    const neighborhood = getNeighborhood(property.zones, NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL)
    return startCase(toLower(neighborhood?.name))
  }, [property.zones])

  if (!insights.length && !children) return null

  return (
    <>
      {children}
      {insights.map(e => (
        <Fragment key={'insights_' + metrics[e.metricIndex]}>
          {e.type === 'SMALLEST' && (
            <InsightCard
              description={`${description[e.metricIndex][1][0]} than all other ${otherLabel[1]} in ${neighborhoodName}.`}
              title={`${description[e.metricIndex][0][0]} ${otherLabel[0]}`}
            />
          )}
          {e.type === 'BIGGEST' && (
            <InsightCard
              description={`${description[e.metricIndex][1][1]} than all other ${otherLabel[1]} in ${neighborhoodName}.`}
              title={`${description[e.metricIndex][0][1]} ${otherLabel[0]}`}
            />
          )}
          {e.type === 'SMALLER' && (
            <InsightCard
              description={`${description[e.metricIndex][1][0]} than ${e.percent > 99.9 ? 99.9 : e.percent.toFixed(1)}% of ${otherLabel[1]} in ${neighborhoodName}.`}
              title={`${description[e.metricIndex][0][2]} ${otherLabel[0]}`}
            />
          )}
          {e.type === 'BIGGER' && (
            <InsightCard
              description={`${description[e.metricIndex][1][1]} than ${e.percent > 99.9 ? 99.9 : e.percent.toFixed(1)}% of ${otherLabel[1]} in ${neighborhoodName}.`}
              title={`${description[e.metricIndex][0][3]} ${otherLabel[0]}`}
            />
          )}
        </Fragment>
      ))}
    </>
  )
}

export default Insights
